import React from 'react';

import { Heading, Slide, Section } from 'spectacle-ppa';
import TeamNames from 'components/teamNames';

function teamCreationSection () {
  return (
    <Section id="team-creation">

      {/* Enter team names */}
      <Slide
          id="assign"
          bgColor="black"
          notes="<h2>Assign Team Names</h2>"
          teamNames>
        <div className="ui-slide">
          <Heading size={1}>
            Name your teams!
          </Heading>
          <TeamNames />
        </div>
      </Slide>

    </Section>

  );
}

export default teamCreationSection;



// WEBPACK FOOTER //
// ./programs/epsHybridAssembly/sections/01_teamCreation/teamCreationSection.jsx